import * as GuidedTourActions from 'app/guided-tour/state/guided-tour.actions';

import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { User } from 'app/classes/user';
import { StartTourDialogComponent } from 'app/guided-tour/components/start-tour-dialog/start-tour-dialog.component';
import { GuidedTourSelectors } from 'app/guided-tour/state/guided-tour.selectors';
import { AuthService } from 'app/services/auth.service';
import { GuidedTourDataService } from 'app/services/guided-tour-data.service';
import { OfflineService } from 'app/services/offline.service';
import { environment } from '../../../environments/environment';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  isOnline: boolean;
  version: string = environment.version;
  feedback = '';
  inputValid = true;
  successMessage = false;
  errorMessage = false;
  currentUser: User;
  currentUserSub: Subscription = new Subscription();
  guidedTourToggledOn: boolean;
  guidedTourStatusSub: Subscription;

  @Select(GuidedTourSelectors.toggleStatus)guidedTourToggleStatus$: Observable<boolean>;

  constructor(
    private router: Router,
    private authService: AuthService,
    public offline: OfflineService,
    private guidedTourDataService: GuidedTourDataService,
    private store: Store,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.offline.tryPingServer();
    this.isOnline = this.offline.isOnline();
    this.offline.status.subscribe(value => {
      this.isOnline = value;
    });
    this.currentUserSub = this.authService.currentUserObs.subscribe(user => {
      this.currentUser = user;
    });

    const dialogRef = this.dialog.open(StartTourDialogComponent, {
      width: '350px',
      height: '150px',
      hasBackdrop: false
    });
    setTimeout(() => {
      dialogRef.close();
    }, 10000);
  }

  ngAfterViewInit() {
    this.store.dispatch(new GuidedTourActions.GetGuidedTourToggleStatus());
    this.guidedTourStatusSub = this.guidedTourToggleStatus$.subscribe(status => {
      if (status !== undefined) {
        this.guidedTourToggledOn = status;
        if (this.guidedTourToggledOn) {
          setTimeout(() => this.guidedTourDataService.startGuidedTour('dashboard'), 1000);
        }
      }
    });
  }

  ngOnChanges(): void {
  }

  ngOnDestroy() {
    this.currentUserSub.unsubscribe();
    if (this.guidedTourStatusSub) {
      this.guidedTourStatusSub.unsubscribe();
    }
    this.dialog.closeAll();
  }

  createPlan() {
    this.router.navigate(['planning']);
  }

  viewManagement() {
    this.router.navigate(['management']);
  }

  viewTrends() {
    this.router.navigate(['explore']);
  }

}
